import Vue from "vue";
import VueI18n from "vue-i18n";
import { getLocale } from "@/lib/localeHelper";
import { messages } from "@/locales";

Vue.use(VueI18n);

export default new VueI18n({
  locale: getLocale(),
  fallbackLocale: "en",
  silentTranslationWarn: true,
  formatFallbackMessages: true,
  messages,
});
